import React from "react";
import Markdown from "../chat/Markdown";

const DISALLOWED_ELEMENTS = ["img"];

export default function ChatUatMarkdown({ text }: { text: string }) {
  return <Markdown text={text} disallowedElements={DISALLOWED_ELEMENTS} />;
}
